import { useAppStore } from "../store/appStore";
import { generateLocalTimestamp } from "../utils/sessionUtils";

/**
 * 文字起こし関連の状態とアクションを提供する薄いフック。
 * 音声認識そのものは recordingSession（SpeechRecognitionController）が管理する。
 */
export const useSpeechRecognition = () => {
	const transcriptionText = useAppStore((state) => state.transcriptionText);
	const isListening = useAppStore((state) => state.isListening);
	const error = useAppStore((state) => state.recognitionError);

	// 文字起こしをテキストファイルとしてダウンロード保存する
	const saveTranscriptionToFile = async () => {
		if (!transcriptionText) {
			return;
		}

		try {
			// ファイル名生成（現在のローカル時刻を使用）
			const timestamp = generateLocalTimestamp();
			const filename = `transcription_${timestamp}.txt`;

			// Blobに変換
			const blob = new Blob([transcriptionText], {
				type: "text/plain;charset=utf-8",
			});

			// ブラウザでダウンロード
			const url = URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = filename;
			document.body.appendChild(a);
			a.click();

			// クリーンアップ
			setTimeout(() => {
				document.body.removeChild(a);
				URL.revokeObjectURL(url);
			}, 0);

			return true;
		} catch (err) {
			console.error("文字起こしファイルの保存に失敗しました:", err);
			return false;
		}
	};

	return {
		isListening,
		saveTranscriptionToFile,
		error,
	};
};
